export default "__VITE_ASSET__DDBaHpix__"